import styled, { css } from 'styled-components';

type Props = {
  hide: boolean;
};

export const Wrapper = styled.div<Props>`
  flex: 1;
  text-align: left;
  position: relative;
  opacity: 0;
  transition: 0.1s ease-out all;
  color: #000;
  &:first-child {
    opacity: 0;
    transition: 0.1s ease-out all;
  }
  ${props =>
    !props.hide &&
    css`
      opacity: 1;
      transition: 0.1s ease-in-out all;
    `};
`;
export const Inner = styled.span`
  position: absolute;
  transform: translate(-50%, 0px);
  font-size: 11px;
  font-weight: 600;
  bottom: 6px;
`;
